/*
 * File di configurazione dell'applicazione per la definizione delle costanti globali
 */
define([
    'angular'
],
    function (angular) {

        var configModule = angular.module('configModule', []);

        var ambiente = 1;

        var CONTEXT_HOST_SERVICE = [
            'https://WHL14982.replynet.prv:9447',
            ''
            ][ambiente];

        var CONTEXT_ROOT_WEB = '/registrazione-ente-angular/';

        /*
         * URL per richiamare i servizi REST
         */
        var CONTEXT_REST_SERVICE = CONTEXT_HOST_SERVICE + '/registrazione-ente-rest/jaxrs/';

        /* 
         * Variabile per evitare la cache delle risorse da parte del browser
         */
        var urlParamsValue = __COMMIT_HASH__;
        var urlArgs = "?v=" + urlParamsValue;

        var CONSTANTS = {
            'URL_ARGS': urlArgs,
            'HOME_PAGE': CONTEXT_ROOT_WEB,
            '401_PAGE': CONTEXT_ROOT_WEB + '#nologin',
            '403_PAGE': CONTEXT_ROOT_WEB + '#noauth',
            '404_PAGE': CONTEXT_ROOT_WEB + '404.html',
            'TELEM_PAGE': CONTEXT_ROOT_WEB + 'telem.html',
           // 'LOGIN_PAGE': CONTEXT_ROOT_WEB + 'login.html',
            'ERROR_PAGE': CONTEXT_ROOT_WEB + 'error.html',
            'VERIFICA_CF': CONTEXT_REST_SERVICE + 'anagrafica/verifica/',
            'CODICE_FISCALE': CONTEXT_REST_SERVICE + 'registrazione/codice-fiscale/',
            'DO_INVIA': CONTEXT_REST_SERVICE + 'registrazione/registraEnte/',
            'DO_SCARICA_PDF': CONTEXT_REST_SERVICE + 'registrazione/downloadRichiestaPdf/',
            'DO_DELEGA': CONTEXT_REST_SERVICE + 'registrazione/delega/upload/',
            'VERIFICA_DELEGA': CONTEXT_REST_SERVICE + 'registrazione/delega/',
            'VERIFICA_FILE_DELEGA': CONTEXT_REST_SERVICE + 'commons/documenti/verifica-antivirus/',
            'VERIFICA_VIRUS_DELEGA': CONTEXT_REST_SERVICE + 'commons/documenti/consultazione-antivirus/',
            'GET_PROVINCE': CONTEXT_REST_SERVICE + 'commons/province',
            'GET_COMUNI': CONTEXT_REST_SERVICE + 'commons/province/{provincia}/comuni',
            'GET_TIPOLOGIE': CONTEXT_REST_SERVICE + 'registrazione/tipologie',
            'GET_CATEGORIE': CONTEXT_REST_SERVICE + 'registrazione/tipologie/{tipologia}',
            'GET_CATEGORIE_SPECIFICHE': CONTEXT_REST_SERVICE + 'registrazione/tipologie/{tipologia}/{categoria}',
            'DO_INVIA_RICHIESTA': CONTEXT_REST_SERVICE + 'richiesta/invio/',
            'DO_RICERCA_INVIO': CONTEXT_REST_SERVICE + 'richiesta/ricerca-invio/',
            'DO_ANNULLA': CONTEXT_REST_SERVICE + 'richiesta/annulla/',
            'CHECK_ANNULLA': CONTEXT_REST_SERVICE + 'richiesta/annulla-check/',
            'DO_VARIAZIONE_CERCA': CONTEXT_REST_SERVICE + 'richiesta/variazione/search/',
            'DO_VARIAZIONE_SALVA': CONTEXT_REST_SERVICE + 'richiesta/variazione/save/',
            'DO_VARIAZIONE_SALVA_INVIA': CONTEXT_REST_SERVICE + 'richiesta/variazione/save/send/',
            'DO_VARIAZIONE_ELIMINA': CONTEXT_REST_SERVICE + 'richiesta/variazione/delete/',
            'DO_VARIAZIONE_ELIMINA_CERCA': CONTEXT_REST_SERVICE + 'richiesta/variazione/search/delete/',
            'DO_VARIAZIONE_DOWNLOAD': CONTEXT_REST_SERVICE + 'richiesta/variazione/download/',
            'DO_VARIAZIONE_INVIA': CONTEXT_REST_SERVICE + 'richiesta/variazione/send/',
            'DO_CONTROLLO_INSERIMENTO': CONTEXT_REST_SERVICE + 'richiesta/variazione/inserimento/',
            'DO_CONTROLLO_INVIA_RICHIESTA': CONTEXT_REST_SERVICE + 'richiesta/variazione/inviarichiesta/',
            'DO_CONTROLLO_VARIAZIONE_SAVED': CONTEXT_REST_SERVICE + 'richiesta/variazione/saved/',
            'PATH_CAPTCHA': CONTEXT_REST_SERVICE + 'captcha',
            'DEBUG': true,
            'MESSAGES_ID': 'messages-container',
            'CAPTCHA_ENABLED': false,
            'CONTEXT_REST_SERVICE': CONTEXT_REST_SERVICE
        };

        configModule.constant('CONSTANTS', CONSTANTS);

        return configModule;
    });



//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/config.js
// module id = 31
// module chunks = 1